// extracted by mini-css-extract-plugin
export var button = "add-meal-modal-module--button--0d607";
export var form = "add-meal-modal-module--form--43bb9";
export var globalError = "add-meal-modal-module--global-error--6284b";
export var inputFile = "add-meal-modal-module--input-file--23409";
export var inputFileInfo = "add-meal-modal-module--input-file-info--75a2f";
export var inputRow = "add-meal-modal-module--input-row--08e2b";
export var modal = "add-meal-modal-module--modal--de488";
export var separator = "add-meal-modal-module--separator--abf0e";